import { angelopolisApi } from "../../api/angelopolisAPi";
import { AsesorCotizador } from "./AsesorCotizador";
import { ZoneModalInfo } from "./ZoneInfoModal";

export class ModalControler {
  constructor() {
    // define singleton intance
    if (ModalControler.instance) {
      return ModalControler.instance;
    }
    this.angelApi = new angelopolisApi();
    this.modalPDFAsesor = new AsesorCotizador();
    this.dataApi = [];
    this.dataApi = this.angelApi.getApiData();
    // this.getDataCloustersApi();
    ModalControler.instance = this;

    this.lastLoteOpend = {};
    this.optionsIntereses = {};
    this.plazos = 0;
    this.contraentregaGeneralvalue = 0;
    this.defaultEscrituraPrice = 10;
    this.enganche = 0;
    this.enablePresentValue = false;
    this.objectHtml = document.querySelector("#modalInfoTerrain");

    this.viewPercentMensualidad = document.querySelector(
      "#viewPercentMensualidad"
    );
    this.viewPercentContraentrega = document.querySelector(
      "#viewPercentContraentrega"
    );
    this.viewContraentregaGeneral = document.querySelector(
      "#viewContraentregaGeneral"
    );
    this.btnmodalasesorCotizador = document.querySelector(
      "#btn-modal-asesorCotizador"
    );
    this.viewContraentrega = document.querySelector("#viewContraentrega");
    this.percentMensualidades = document.querySelector("#percentMensualidades");
    this.percentcontraentrega = document.querySelector("#percentcontraentrega");
    this.monto_contraentrega = document.querySelector("#monto_contraentrega");

    this.titleLote = document.querySelector("#titleLote");
    this.dimensionLote = document.querySelector("#dimensionLote");
    this.ubicationLote = document.querySelector("#ubicationLote");
    this.statusLote = document.querySelector("#statusLote");
    this.price12Months = document.querySelector("#price12Months");
    this.priceM12M = document.querySelector("#priceM12M");
    this.calMonto = document.querySelector("#calMonto");
    this.calMes = document.querySelector("#calMes");
    this.calTotal = document.querySelector("#calTotal");
    this.linkplane = document.querySelector("#linkplane");

    this.dropdownenganche = document.querySelector("#dropdownenganche");
    this.dropdownplazo = document.getElementById("dropdownplazo");
    this.contraentregageneral = document.getElementById("contraentregageneral");

    // this.title = document.querySelector("#titleModalInfoTerrain")
    this.closeIcon = document.querySelector("#closeIcon");
    this.modalZoneInfo = new ZoneModalInfo();
    this.initListeners();
  }

  showModal(title = String) {
    if (this.objectHtml.classList.contains("hidden")) {
      const titleFLote = title.split("_MT")[0];
      this.modalZoneInfo.hideModal();
      this.objectHtml.classList.replace("hidden", "flex");
      this.setDataModal(
        this.removeAccents(titleFLote),
        this.removeAccents(title)
      );
    }
  }
  hideModal() {
    if (this.objectHtml.classList.contains("flex")) {
      this.modalZoneInfo.showModal("", false);
      this.objectHtml.classList.replace("flex", "hidden");
    }
    this.viewPercentMensualidad.classList.replace("no-hidden", "hidden");
    this.viewPercentContraentrega.classList.replace("no-hidden", "hidden");
    this.viewContraentregaGeneral.classList.replace("no-hidden", "hidden");
    this.viewContraentrega.classList.replace("no-hidden", "hidden");
    this.dropdownplazo.disabled = false;
    this.contraentregageneral.disabled = false;
  }

  initListeners() {
    this.btnmodalasesorCotizador.addEventListener("click", () => {
      this.modalPDFAsesor.openModal();
    });

    this.closeIcon.addEventListener("click", () => {
      this.enablePresentValue = false;
      this.hideModal();
    });

    this.dropdownenganche.addEventListener("change", (e) => {
      this.enganche = parseFloat(e.target.value);
      //
      console.log(this.enablePresentValue);
      if (!this.enablePresentValue) {
        if (parseFloat(e.target.value) === 1) {
          this.dropdownplazo.disabled = true;
          this.dropdownplazo.add(new Option(`1 mes`, "1"));
          this.dropdownplazo.value = "1";
          this.plazos = 1;
          this.contraentregageneral.disabled = true;
        } else {
          this.dropdownplazo.disabled = false;
          this.contraentregageneral.disabled = false;
          for (var i = 0; i < this.dropdownplazo.length; i++) {
            if (this.dropdownplazo.options[i].value == "1")
              this.dropdownplazo.remove(i);
          }
          // this.setDropDowns(this.lastLoteOpend)
        }
        if (this.enganche === 0.1) {
          this.contraentregageneral.value = this.enganche * 100;
          this.contraentregaGeneralvalue = this.enganche * 100;
          this.contraentregageneral.options[1] = new Option(
            `${this.enganche * 100}%`,
            this.enganche * 100
          );
          this.contraentregageneral.options[2] = new Option(`${20}%`, 20);
          
        } 
        else if (this.enganche === 0.2) {
          this.contraentregageneral.value = this.enganche * 100;
          this.contraentregaGeneralvalue = this.enganche * 100;
          this.contraentregageneral.options[1] = new Option(
            `${this.enganche * 100}%`,
            this.enganche * 100
          );
          this.contraentregageneral.options.remove(2)
        } 
        else if(this.enganche === 1){
          this.contraentregageneral.options[0] = new Option(`0%`, 0);
          this.contraentregageneral.value = 0;
          this.contraentregaGeneralvalue = 0;
          this.contraentregageneral.options.remove(2)
        }
        else {
          this.contraentregageneral.options[1] = new Option(`20%`, 20);
          this.contraentregageneral.value = 20;
          this.contraentregaGeneralvalue = 20;
          this.contraentregageneral.options.remove(2)
        }
        this.setCalcules(this.lastLoteOpend);
      } else {
        if (this.enganche === 100) {
          this.dropdownplazo.disabled = true;
          this.dropdownplazo.add(new Option(`1 mes`, "1"));
          this.dropdownplazo.value = "1";
          this.plazos = 1;
          this.contraentregageneral.disabled = true;
        } else {
          this.dropdownplazo.disabled = false;
          this.contraentregageneral.disabled = false;
          for (let i = 0; i < this.dropdownplazo.options.length; i++) {
            if (this.dropdownplazo.options[i].value === "1") {
              this.dropdownplazo.remove(i);
              break;
            }
          }
          this.dropdownplazo.value = this.dropdownplazo.options[0].value;
          this.plazos = parseInt(this.dropdownplazo.value);
        }
        if (this.enganche === 10) {
          this.escritura = this.enganche;
          this.contraentregageneral.options[1] = new Option(
            `${this.escritura}%`,
            this.escritura
          );
          this.contraentregageneral.options[2] = new Option(`${20}%`, 20);
          this.contraentregageneral.value = this.escritura;
        }
       else if (this.enganche === 15 || this.enganche === 20) {
          this.escritura = this.enganche;
          this.contraentregageneral.options[1] = new Option(
            `${this.escritura}%`,
            this.escritura
          );
          this.contraentregageneral.value = this.escritura;
          this.contraentregageneral.options.remove(2)
        } else if (this.enganche >= 60) {
          this.escritura = (100 - this.enganche) / 2;
          this.contraentregageneral.options[1] = new Option(
            `${this.escritura}%`,
            this.escritura
          );
          this.contraentregageneral.value = this.escritura;
          this.contraentregageneral.options.remove(2)
        } else {
          this.escritura = 20;
          this.contraentregageneral.options.remove(2)
          this.contraentregageneral.options[1] = new Option(
            `${this.escritura}%`,
            this.escritura
          );
          this.contraentregageneral.value = this.escritura;
        }
        this.setCalculatesPresentValue(this.lastLoteOpend);
      }
    });

    this.dropdownplazo.addEventListener("change", (e) => {
      this.plazos = parseInt(e.target.value);
      // TODO change if is new cotizador
      if (!this.enablePresentValue) {
        this.setCalcules(this.lastLoteOpend);
      } else {
        this.setCalculatesPresentValue(this.lastLoteOpend);
      }
    });
    this.contraentregageneral.addEventListener("change", (e) => {
      if (!this.enablePresentValue) {
        this.contraentregaGeneralvalue = parseInt(e.target.value);
        this.setCalcules(this.lastLoteOpend);
      }
      else{
        this.escritura = parseInt(e.target.value);
        this.setCalculatesPresentValue(this.lastLoteOpend);
      }
    });
  }

  round5(x) {
    // return x
    return Math.ceil(x / 5) * 5;
  }
  roundedTwoDecimals(number) {
    return Math.round(number * 100) / 100;
  }
  roundedOneDecimals(number) {
    return Math.round(number * 10) / 10;
  }
  roundTenDecimals(number) {
    let factor = Math.pow(10, 10);
    return Math.round(number * factor) / factor;
  }

  convertToFormat(number) {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  setDataModal(titleFLote, title) {
    this.dropdownenganche.innerHTML = "";
    this.dropdownplazo.innerHTML = "";
    let finalName = titleFLote;
    // console.log("titleFLote:", titleFLote);
    // console.log("title:", title);
    // console.log(titleFLote.split("_"));
    // console.log("--");
    const titlesplit = titleFLote.split("_");
    // if (titleFLote === "VICTORIA_1") {
    //   finalName = "VICTORIA 01";
    // }
    // console.log("Nombre modelo", title);
    const find = this.dataApi.find(
      (lote) => {
        // console.log(lote);
        const deletePoints = lote.NombreBusqueda.replace(/\./g, " ");
        const loteSplit = deletePoints.split(" ");
        const loteNormalize = loteSplit.map((x) => this.removeAccents(x));

        // console.log(loteSplit);
        if (
          parseInt(loteNormalize[loteNormalize.length - 1]) ===
          parseInt(titlesplit[titlesplit.length - 1])
        ) {
          if (
            loteNormalize[loteNormalize.length - 2].toUpperCase() ===
            titlesplit[titlesplit.length - 2].toUpperCase()
          ) {
            // console.log(loteNormalize);
            // console.log(titlesplit);
            return lote;
          }
        }
      }
      // (lote) => lote.NombreBusqueda === finalName
    );
    // console.log(find);
    if (find) {
      // find.Disponibilidad = 10;
      // find.Precio = 10;
      if (find.Precio === 0) {
        this.hideModal();
      }
      switch (title) {
        case "_1RA_CERRADA_DE_BALOS_2_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "_2DA_CERRADA_DE_BALOS_2_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "_1RA_CERRADA_DE_BALOS_5_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "CERRADA_SAN_BERNARDINO_5_MT_G_disponible_0":
          this.hideModal();
          break;

        case "AURORA_32_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "MISTRAL_18_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "ROCIO_1_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "CERRADA_BARTELL_2_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "PRIVADA_MILATOS_5_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "MILATOS_20_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "CERRADA_DE_JAVA_1_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "GALERNA_6_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "SAN_GABRIEL_8_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "SAN_GABRIEL_6_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "PRIVADA_MILATOS_10_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "PRIVADA_MILATOS_8_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "PRIVADA_MILATOS_6_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "PRIVADA_MILATOS_4_MT_G_noDisponible_0":
          this.hideModal();
          break;

        case "PRIVADA_MILATOS_2_MT_G_noDisponible_0":
          this.hideModal();
          break;

        default:
          break;
      }

      if (find.Detalle.length >= 1) {
        if (
          find.Almacen === "A-119A" ||
          find.Almacen === "A-119B" ||
          find.Almacen === "A-114D" ||
          find.Almacen === "A-118" ||
          find.Almacen === "C4" ||
          find.Almacen === "A-115AB" ||
          find.Almacen === "A-35" ||
          find.Almacen === "A-101D"

        ) {
          this.viewPercentMensualidad.classList.replace("hidden", "no-hidden");
          this.viewContraentregaGeneral.classList.replace(
            "hidden",
            "no-hidden"
          );
          // this.viewPercentContraentrega.classList.replace(
          //   "hidden",
          //   "no-hidden"
          // );
          this.viewContraentrega.classList.replace("hidden", "no-hidden");
          // new cotizador in new clouster
          this.setDropDownsNewCotizacion(find);
          this.enablePresentValue = true;
          this.setCalculatesPresentValue(find);
        } else {
          this.viewContraentrega.classList.replace("hidden", "no-hidden");
          this.viewContraentregaGeneral.classList.replace(
            "hidden",
            "no-hidden"
          );
          this.optionsIntereses = this.setDropDowns(find);
          this.setCalcules(find);
        }
      } else {
        this.hideModal();
      }
      this.lastLoteOpend = find;
      this.setInfoLote(find);
    } else {
      this.hideModal();
      this.titleLote.innerText = "Vendido no encontrado";
      this.dimensionLote.innerText = "Vendido";
      this.ubicationLote.innerText = "Vendido";
      this.statusLote.innerHTML = "Vendido";
      this.price12Months.innerText = "Vendido";
      this.priceM12M.innerText = "Vendido";
      this.calMonto.innerText = "Vendido";
      this.calMes.innerText = "Vendido";
      this.calTotal.innerText = "Vendido";
    }
  }

  setDropDowns(lote) {
    const options = lote.Detalle;
    let optionsClear = options.map((opt) => {
      const meses = parseFloat(opt._attributes.Meses);
      const intereses = parseFloat(opt._attributes.Interes);
      const name = opt._attributes.Nombre;
      // if (name === "Contado (1 Exhibición)") {
      //   name = "Enganche 100%";
      // }
      const numerOfPercent = name.split(" ")[1].split("%")[0];
      try {
        const enganche = parseFloat(numerOfPercent) / 100;
        if (enganche) {
          return {
            enganche,
            meses,
            intereses,
          };
        }
      } catch (error) {
        console.log(error);
      }
    });
    optionsClear.push({
      enganche: 1,
      intereses: 0,
      meses: 1,
    });
    optionsClear = optionsClear.filter((item) => item);
    const engancheToDropdown = this.getUniqueListBy(optionsClear, "enganche");
    const mesesToDropdown = this.getUniqueListBy(optionsClear, "meses");
    engancheToDropdown.map((option) => {
      if (option.enganche !== null && option.enganche !== 1) {
        this.dropdownenganche.add(
          new Option(`${option.enganche * 100}%`, option.enganche)
        );
        // arcodear enganche del 20 porciento
        // dentro del if para que visualmente este despues del 10 prociento y no al final
        if (option.enganche === 0.1) {
          this.dropdownenganche.add(new Option(`${20}%`, 0.2));
        }
        //
      } else if (option.meses !== null && option.enganche === 1) {
        this.dropdownenganche.add(
          new Option(`1 Exhibición (contado)`, option.enganche)
        );
      }
    });
    mesesToDropdown.map((option) => {
      if (option.meses !== 1) {
        this.dropdownplazo.add(
          new Option(`${option.meses} meses`, option.meses)
        );
      }
    });
    // selector de precio inicial
    this.enganche = engancheToDropdown[0].enganche;
    this.plazos = mesesToDropdown[0].meses;

    this.contraentregageneral.options[1] = new Option(
      `${this.enganche * 100}%`,
      this.enganche * 100
    );
    this.contraentregageneral.value = this.enganche*100
    this.contraentregaGeneralvalue= this.enganche*100
    this.contraentregageneral.options[2] = new Option(`${20}%`, 20);

    // console.log(mesesToDropdown);
    for (var i = 0; i < this.dropdownplazo.length; i++) {
      if (this.dropdownplazo.options[i].value == "18")
        this.dropdownplazo.value = "18";
      this.plazos = 18;
    }
    return optionsClear;
  }

  getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }

  setInfoLote(find) {
    this.titleLote.innerText = find.street.split(".").join(" ");
    if (find.image !== "N/A") {
      this.linkplane.classList.remove("invisible");
      this.linkplane.href = find.image;
    } else {
      this.linkplane.classList.add("invisible");
    }

    this.dimensionLote.innerText = find.Disponibilidad + "m2";
    let clousterName = find.CodigoProducto.split(" ")[0];
    if (clousterName === "LIGARCADIA") {
      clousterName = "Arcadia";
    }
    if (clousterName === "BALI.RESIDENCIAL") {
      clousterName = "Bali";
    }
    if (clousterName === "CANTERA") {
      clousterName = "La Cantera";
    }
    this.ubicationLote.innerText = clousterName;
    // this.ubicationLote.innerText = find.Almacen;
    if (find.Detalle.length <= 0) {
      this.statusLote.innerHTML = "No disponible";
      this.price12Months.innerText = 0;
      this.priceM12M.innerText = 0;
      this.calMonto.innerText = 0;
      this.calMes.innerText = 0;
      this.calTotal.innerText = 0;
    } else {
      this.statusLote.innerHTML = find.EstadoComercial;
    }
  }
  setCalcules(find) {
    console.log(find);
    const priceFMC = parseFloat(find.Precio);
    const comercialPrice = this.roundedTwoDecimals(priceFMC * 1); //.0566

    // selector % increment
    let incrementPercent = 0;
    // console.log(this.optionsIntereses);
    let finded = this.optionsIntereses.find(
      (opt) => opt.enganche === this.enganche && opt.meses === this.plazos
    );

    // Si el usuario seleciona enganche de 20% ya esta arcodeado los intereses
    // que debe tomer son los de enganche del 10% osea 0.1 que es el if de abajo
    if (this.enganche === 0.2 && find.Almacen != "C3") {
      finded = this.optionsIntereses.find(
        (opt) => opt.enganche === 0.1 && opt.meses === this.plazos
      );
    }

    if (finded) {
      incrementPercent = finded.intereses / 100;
    }
    // //
    const totalMeters = parseFloat(find.Disponibilidad);

    // // to 12 monts
    // let incrementPercentto12 = 0;
    // const findedto12 = this.optionsIntereses.find(
    //   (opt) => opt.enganche === 0.1 && opt.meses === 12
    // );
    // if (findedto12) {
    //   incrementPercentto12 = findedto12.intereses / 100;
    // }
    //
    // ////////////////////////////////////////////
    const priceFinale = this.round5(
      Math.round(parseFloat(comercialPrice + comercialPrice * incrementPercent))
    );
    // console.log("*****---****---***");
    // console.log(this.contraentregaGeneralvalue);

    const priceFinal = Math.round(priceFinale * 1.06);
    this.priceM12M.innerText = this.convertToFormat(priceFinal);
    // console.log(priceFinal);

    const engancheF = priceFinal * totalMeters * this.enganche;
    //
    this.calMonto.innerText = this.convertToFormat(
      this.roundedTwoDecimals(engancheF)
    );
    //
    const costoContraentrega =
      priceFinal * totalMeters *  (this.contraentregaGeneralvalue / 100);
    const costMensaulidades =
      priceFinal * totalMeters - engancheF - costoContraentrega;

    const costoPorMes = costMensaulidades / this.plazos;

    this.calMes.innerText = this.convertToFormat(
      this.roundedTwoDecimals(costoPorMes)
    );
    //
    this.calTotal.innerText = this.convertToFormat(
      this.roundedTwoDecimals(
        costoContraentrega + engancheF + costoPorMes * this.plazos
      )
    );
    this.price12Months.innerText = this.convertToFormat(
      this.roundedTwoDecimals(
        costoContraentrega + engancheF + costoPorMes * this.plazos
      )
    );
    this.monto_contraentrega.innerText = this.convertToFormat(
      costoContraentrega
    );

    //
    // para generar pdf envia la informacion de la cotizacion por el singleton
    this.modalPDFAsesor.infoPrice = {
      type: 0,
      maintenanceMount: 0,
      loteinfo: find,
      priceMeter: priceFinal,
      priceFinancial: this.roundedTwoDecimals(
        costoContraentrega + engancheF + costoPorMes * this.plazos
      ),
      engancheValue: this.enganche,
      engancheAmount: this.roundedTwoDecimals(engancheF),
      plazo: this.plazos===1?0:this.plazos,
      mensualidad: this.roundedTwoDecimals(costoPorMes),
      priceFinal: this.roundedTwoDecimals(
        costoContraentrega + engancheF + costoPorMes * this.plazos
      ),
      mensualidadValue:
        100 - this.contraentregaGeneralvalue - this.enganche * 100,
      percentageContraEntrega: this.contraentregaGeneralvalue / 100,
      mountContraEntrega: costoContraentrega,
      // not discount
      notDicountPlazo: this.plazos===1?0:this.plazos,
      notDiscountpriceMeter: priceFinal,
      notDiscountenganche: this.roundedTwoDecimals(engancheF),
      notDiscountContraenetrega: costoContraentrega,
      notDiscountmenusalidad: this.roundedTwoDecimals(costoPorMes),
      notDiscountpriceFinancial: this.roundedTwoDecimals(
        costoContraentrega + engancheF + costoPorMes * this.plazos
      ),
    };
    // console.log(100 - this.contraentregaGeneralvalue - this.enganche * 100);
  }

  //  for new form to calcutate prices

  mesesFaltantesHastaFechaEspecifica(lote) {
    let fechaEspecifica = "";
    if (lote.Almacen === "A-114D") {
      fechaEspecifica = "2027-03-01";
    }
    if (lote.Almacen === "A-119A") {
      fechaEspecifica = "2027-03-01";
    }
    if (lote.Almacen === "A-119B") {
      fechaEspecifica = "2027-03-01";
    }
    if (lote.Almacen === "A-118") {
      fechaEspecifica = "2027-05-01";
    }
    if (lote.Almacen === "A-115AB") {
      fechaEspecifica = "2027-05-01";
    }
    if (lote.Almacen === "C4") {
      fechaEspecifica = "2027-12-01";
    }
    if (lote.Almacen === "A-35") {
      fechaEspecifica = "2027-04-01";
    }
    if (lote.Almacen === "A-101D") {
      fechaEspecifica = "2027-04-01";
    }
    var fechaActual = new Date();
    var fechaObjetivo = new Date(fechaEspecifica);
    var diferenciaMeses =
      (fechaObjetivo.getFullYear() - fechaActual.getFullYear()) * 12 +
      fechaObjetivo.getMonth() -
      fechaActual.getMonth();
    if (fechaObjetivo < fechaActual) {
      return 0;
    } else if (
      fechaObjetivo.getMonth() === fechaActual.getMonth() &&
      fechaObjetivo.getFullYear() === fechaActual.getFullYear()
    ) {
      return 0;
    } else {
      return diferenciaMeses;
    }
  }

  setCalculatesPresentValue(lote) {
    console.log(this.enganche, this.plazos, this.escritura);
    // 
    let mesesBase = this.mesesFaltantesHastaFechaEspecifica(lote);
    if (lote.Almacen === "C4" && mesesBase >= 24) {
      mesesBase = 24;
    }

    // console.clear();
    console.log("meses faltan:" + mesesBase);
    const defaultTasa = 0.13;
    let tasa = 0.13;
    const clusterFind = this.angelApi.clusters.find(
      (cluster) => cluster.slug === lote.Almacen
    );
    tasa = clusterFind.interestRate / 100;
    // tasa cambia si los meses sobrepasan el default
    if (this.plazos - mesesBase >= 1) {
      tasa = 0.17;
    }
    console.log("tasa selected: " + tasa);
    const priceFMC = parseFloat(lote.Precio);
    const comercialPrice = this.roundedTwoDecimals(priceFMC * 1);
    const priceCompleteMeters =  comercialPrice * lote.meters;
    console.log("precio base:" + priceCompleteMeters);
    // print results
    console.log("---------------costos default----------------");
    const enganche_standar = this.roundedTwoDecimals(
      priceCompleteMeters * (15 / 100)
    );
    const totalFinanciar_standar = this.roundedTwoDecimals(
      priceCompleteMeters * ((100 - 15 - 25) / 100)
    );
    const mensualidad_standar = this.roundedTwoDecimals(
      totalFinanciar_standar / mesesBase
    );
    const montoEscritura_standar = this.roundedTwoDecimals(
      priceCompleteMeters * (25 / 100)
    );
    console.log("enganche_standar:" + enganche_standar);
    console.log("mensualidades_standar:" + mensualidad_standar);
    console.log("escritura_standar:" + montoEscritura_standar);
    const enganche = this.roundedTwoDecimals(
      priceCompleteMeters * (this.enganche / 100)
    );
    const totalFinanciar = this.roundedTwoDecimals(
      priceCompleteMeters * ((100 - this.enganche - this.escritura) / 100)
    );
    const mensualidad = this.roundedTwoDecimals(totalFinanciar / this.plazos);
    const montoEscritura = this.roundedTwoDecimals(
      priceCompleteMeters * (this.escritura / 100)
    );
    console.log("---------------costos calcualando----------------");
    console.log("enganche:" + enganche);
    console.log("montofinanciado:" + totalFinanciar);
    console.log("mensualidades:" + mensualidad);
    console.log("escritura:" + montoEscritura);

    // Formulas ---------------------------
    //
    //
    // VNA standar
    const flujos_standar = [];
    for (let index = 0; index < mesesBase; index++) {
      flujos_standar.push(mensualidad_standar);
    }
    flujos_standar.push(montoEscritura_standar);

    const VNA_standar = Math.round(
      this.calcularVNA(defaultTasa, flujos_standar, enganche_standar)
    );
    console.log(VNA_standar);
    //

    // VNA del calculo seleccionado
    const flujos = [];
    for (let index = 0; index < this.plazos; index++) {
      flujos.push(mensualidad);
    }
    flujos.push(montoEscritura);
    console.log(flujos);
    // const VNA = Math.round(this.calcularVNA(1.010236844, flujos, enganche));
    const VNA = Math.round(this.calcularVNA(tasa, flujos, enganche));
    console.log("VNA:" + VNA);
    //
    const discount = (VNA - VNA_standar) / VNA_standar;
    const minimunPrice = priceCompleteMeters / (1 + discount);
    console.log("precio minimo:" + minimunPrice);

    const enganche_alternativo = this.roundedTwoDecimals(
      minimunPrice * (this.enganche / 100)
    );
    const totalFinanciar_alternativo = this.roundedTwoDecimals(
      minimunPrice * ((100 - this.enganche - this.escritura) / 100)
    );
    const mensualidad_alternativo = this.roundedTwoDecimals(
      totalFinanciar_alternativo / this.plazos
    );
    const montoEscriturar_alternativo = this.roundedTwoDecimals(
      minimunPrice * (this.escritura / 100)
    );
    console.log("ahorro:" + (priceCompleteMeters - minimunPrice));
    console.log("enganche_alternativo:" + enganche_alternativo);
    console.log("montofinanciado_alternativo:" + totalFinanciar_alternativo);
    console.log("mensualidades_alternativo:" + mensualidad_alternativo);
    console.log("escritura_alternativo:" + montoEscriturar_alternativo);
    //

    //
    // if (this.plazos > 22) {
    //   // cotizacion manual
    //   console.log("enganche:" + enganche);
    //   console.log("montofinanciado:" + totalFinanciar);
    //   console.log("mensualidades:" + mensualidad);
    //   console.log("escritura:" + montoEscritura);
    //   const NPV = this.calcularVNA(
    //     1.01316961113,
    //     flujos_standar,
    //     enganche_standar
    //   );
    //   console.log("NPV:" + NPV);
    //   let NPV_actual = Math.round(
    //     this.calcularVNA(1.01316961113, flujos, enganche)
    //   );
    //   console.log("NPV_actual:" + NPV_actual);
    //   const diferencia = Math.abs(NPV_actual - NPV);
    //   console.log("diferencia" + diferencia);

    //   console.log("**");
    //   let escrituraAumento = montoEscritura;
    //   while (Math.abs(NPV - NPV_actual) > 1) {
    //     let flujosAjustado = [...flujos];
    //     escrituraAumento += 1;
    //     flujosAjustado[flujosAjustado.length - 1] = escrituraAumento;
    //     NPV_actual = Math.round(
    //       this.calcularVNA(1.01316961113, flujosAjustado, enganche)
    //     );
    //     if (escrituraAumento > 491790) {
    //       console.log("break");
    //       break;
    //     }
    //     // console.log(escrituraAumento);
    //   }
    //   console.log("-*-");
    //   console.log(Math.abs(NPV - NPV_actual));
    //   console.log(NPV_actual);
    //   console.log(escrituraAumento);
    //   //
    //   const priceWhitAument = enganche + totalFinanciar + escrituraAumento;
    //   const aumento = Math.abs(
    //     (priceCompleteMeters - priceWhitAument) / priceCompleteMeters
    //   );

    //   console.log("precio aumento:  " + priceWhitAument);
    //   console.log("% de aumento:  " + aumento);

    //   const enganche_aumento = enganche * (1 + aumento);
    //   const montofinanciar_aumento = totalFinanciar * (1 + aumento);
    //   const mendsualidad_aumento = mensualidad * (1 + aumento);
    //   const escritura_aumento = montoEscritura * (1 + aumento);
    //   console.log("enganche-aumento: " + enganche_aumento);
    //   console.log("mensualidad-aumento: " + mendsualidad_aumento);
    //   console.log("escritura-aumento: " + escritura_aumento);

    //   this.price12Months.innerText = this.convertToFormat(
    //     enganche_aumento + montofinanciar_aumento + escritura_aumento
    //   );
    //   this.priceM12M.innerText = this.convertToFormat(
    //     (enganche_aumento + montofinanciar_aumento + escritura_aumento) /
    //       lote.meters
    //   );
    //   this.percentMensualidades.innerText = `${
    //     100 - this.enganche - this.escritura
    //   }%`;
    //   this.percentcontraentrega.innerText = "20%";
    //   this.calMonto.innerText = this.convertToFormat(enganche_aumento);
    //   this.calMes.innerText = this.convertToFormat(mendsualidad_aumento);
    //   this.monto_contraentrega.innerText = this.convertToFormat(
    //     escritura_aumento
    //   );
    //   this.calTotal.innerText = this.convertToFormat(
    //     enganche_aumento + montofinanciar_aumento + escritura_aumento
    //   );
    // } else {
    //
    //
    // impresion en el modal
    this.price12Months.innerText = this.convertToFormat(
      enganche_alternativo +
        totalFinanciar_alternativo +
        montoEscriturar_alternativo
    );
    this.priceM12M.innerText = this.convertToFormat(
      (enganche_alternativo +
        totalFinanciar_alternativo +
        montoEscriturar_alternativo) /
        lote.meters
    );
    this.percentMensualidades.innerText = `${
      100 - this.enganche - this.escritura
    }%`;
    this.percentcontraentrega.innerText = `${this.escritura}%`;
    this.calMonto.innerText = this.convertToFormat(enganche_alternativo);
    this.calMes.innerText = this.convertToFormat(mensualidad_alternativo);
    this.monto_contraentrega.innerText = this.convertToFormat(
      montoEscriturar_alternativo
    );
    this.calTotal.innerText = this.convertToFormat(
      enganche_alternativo +
        totalFinanciar_alternativo +
        montoEscriturar_alternativo
    );
    //
    //
    // para generar pdf envia la informacion de la cotizacion por el singleton
    this.modalPDFAsesor.infoPrice = {
      type: 1,
      maintenanceMount: 0,
      loteinfo: lote,
      ahorro: priceCompleteMeters - minimunPrice,
      priceMeter:
        (enganche_alternativo +
          totalFinanciar_alternativo +
          montoEscriturar_alternativo) /
        lote.meters,
      priceFinancial:
        enganche_alternativo +
        totalFinanciar_alternativo +
        montoEscriturar_alternativo,
      engancheValue: this.enganche / 100,
      engancheAmount: enganche_alternativo,
      plazo: this.plazos === 1 || this.enganche === 100 ? 0 : this.plazos,
      mensualidad: mensualidad_alternativo,
      priceFinal:
        enganche_alternativo +
        totalFinanciar_alternativo +
        montoEscriturar_alternativo,
      mensualidadValue: 100 - this.enganche - this.escritura,
      percentageContraEntrega: this.escritura / 100,
      mountContraEntrega: montoEscriturar_alternativo,
      // not discount
      notDiscountpriceMeter:
        (enganche_alternativo +
          totalFinanciar_alternativo +
          montoEscriturar_alternativo) /
        lote.meters,
      notDicountPlazo:
        this.plazos === 1 || this.enganche === 100 ? 0 : this.plazos,
      notDiscountenganche: enganche_alternativo,
      notDiscountContraenetrega: montoEscriturar_alternativo,
      notDiscountmenusalidad: mensualidad_alternativo,
      notDiscountpriceFinancial:
        enganche_alternativo +
        totalFinanciar_alternativo +
        montoEscriturar_alternativo,
    };
    // }
  }

  setDropDownsNewCotizacion(lote) {
    const mesesBase = this.mesesFaltantesHastaFechaEspecifica(lote);
    console.log(lote)
    if (lote.Almacen === "A-114D") {
      //verona
      this.dropdownenganche.add(new Option(`10%`, 10));
      this.dropdownenganche.add(new Option(`15%`, 15));
      this.dropdownenganche.add(new Option(`20%`, 20));
      this.dropdownenganche.add(new Option(`30%`, 30));
      this.dropdownenganche.add(new Option(`40%`, 40));
      this.dropdownenganche.add(new Option(`50%`, 50));
      this.dropdownenganche.add(new Option(`60%`, 60));
      this.dropdownenganche.add(new Option(`70%`, 70));
      this.dropdownenganche.add(new Option(`80%`, 80));
      this.dropdownenganche.add(new Option(`1 Exhibición (contado)`, 100));
      this.enganche = 10;
      this.dropdownplazo.add(new Option(`3 meses`, 3));
      this.dropdownplazo.add(new Option(`6 meses`, 6));
      this.dropdownplazo.add(new Option(`12 meses`, 12));
      this.dropdownplazo.add(new Option(`18 meses`, 18));
      this.dropdownplazo.add(new Option(`24 meses`, 24));
      this.dropdownplazo.add(new Option(`30 meses`, 30));
      // mesesBase > 12
      //   ? this.dropdownplazo.add(new Option(`12 meses`, 12))
      //   : false;
      // mesesBase > 30
      //   ? this.dropdownplazo.add(new Option(`30 meses`, 30))
      //   : false;

      // this.dropdownplazo.add(
      //   new Option(`${mesesBase} meses`, mesesBase, false, true)
      // );
      this.plazos = 3;
      // default escritura contraentrega
      this.percentcontraentrega.innerText = `${this.defaultEscrituraPrice} %`;
      // this.escritura = this.defaultEscrituraPrice;

      this.escritura = this.defaultEscrituraPrice;
      this.contraentregageneral.options[1] = new Option(
        `${this.defaultEscrituraPrice}%`,
        this.defaultEscrituraPrice
      );
      this.contraentregageneral.options[2] = new Option(`${20}%`, 20);
      this.contraentregageneral.value = this.defaultEscrituraPrice;
    }
    if (lote.Almacen === "A-119A") {
      //trento
      this.dropdownenganche.add(new Option(`10%`, 10));
      this.dropdownenganche.add(new Option(`15%`, 15));
      this.dropdownenganche.add(new Option(`20%`, 20));
      this.dropdownenganche.add(new Option(`30%`, 30));
      this.dropdownenganche.add(new Option(`40%`, 40));
      this.dropdownenganche.add(new Option(`50%`, 50));
      this.dropdownenganche.add(new Option(`60%`, 60));
      this.dropdownenganche.add(new Option(`70%`, 70));
      this.dropdownenganche.add(new Option(`80%`, 80));
      this.dropdownenganche.add(new Option(`1 Exhibición (contado)`, 100));
      this.enganche = 10;

      this.dropdownplazo.add(new Option(`3 meses`, 3));
      this.dropdownplazo.add(new Option(`6 meses`, 6));
      // mesesBase > 12
      //   ? this.dropdownplazo.add(new Option(`12 meses`, 12))
      //   : false;
      // mesesBase > 18
      //   ? this.dropdownplazo.add(new Option(`18 meses`, 18))
      //   : false;
      // mesesBase > 24
      //   ? this.dropdownplazo.add(new Option(`24 meses`, 24))
      //   : false;
      this.dropdownplazo.add(new Option(`12 meses`, 12));
      this.dropdownplazo.add(new Option(`18 meses`, 18));
      this.dropdownplazo.add(new Option(`24 meses`, 24));
      this.dropdownplazo.add(new Option(`30 meses`, 30));
      // this.dropdownplazo.add(
      //   new Option(`${mesesBase} meses`, mesesBase, false, true)
      // );
      this.plazos = 3;
      this.percentcontraentrega.innerText = `${this.defaultEscrituraPrice} %`;
      // this.escritura = this.defaultEscrituraPrice;
      this.escritura = this.defaultEscrituraPrice;
      this.contraentregageneral.options[1] = new Option(
        `${this.defaultEscrituraPrice}%`,
        this.defaultEscrituraPrice
      );
      this.contraentregageneral.options[2] = new Option(`${20}%`, 20);
      this.contraentregageneral.value = this.defaultEscrituraPrice;
    }
    if (lote.Almacen === "A-119B") {
      //trento
      this.dropdownenganche.add(new Option(`10%`, 10));
      this.dropdownenganche.add(new Option(`15%`, 15));
      this.dropdownenganche.add(new Option(`20%`, 20));
      this.dropdownenganche.add(new Option(`30%`, 30));
      this.dropdownenganche.add(new Option(`40%`, 40));
      this.dropdownenganche.add(new Option(`50%`, 50));
      this.dropdownenganche.add(new Option(`60%`, 60));
      this.dropdownenganche.add(new Option(`70%`, 70));
      this.dropdownenganche.add(new Option(`80%`, 80));
      this.dropdownenganche.add(new Option(`1 Exhibición (contado)`, 100));
      this.enganche = 10;

      this.dropdownplazo.add(new Option(`3 meses`, 3));
      this.dropdownplazo.add(new Option(`6 meses`, 6));
      // mesesBase > 12
      //   ? this.dropdownplazo.add(new Option(`12 meses`, 12))
      //   : false;
      // mesesBase > 18
      //   ? this.dropdownplazo.add(new Option(`18 meses`, 18))
      //   : false;
      // mesesBase > 24
      //   ? this.dropdownplazo.add(new Option(`24 meses`, 24))
      //   : false;
      this.dropdownplazo.add(new Option(`12 meses`, 12));
      this.dropdownplazo.add(new Option(`18 meses`, 18));
      this.dropdownplazo.add(new Option(`24 meses`, 24));
      this.dropdownplazo.add(new Option(`30 meses`, 30));
      // this.dropdownplazo.add(
      //   new Option(`${mesesBase} meses`, mesesBase, false, true)
      // );
      this.plazos = 3;
      this.percentcontraentrega.innerText = `${this.defaultEscrituraPrice} %`;
      // this.escritura = this.defaultEscrituraPrice;
      this.escritura = this.defaultEscrituraPrice;
      this.contraentregageneral.options[1] = new Option(
        `${this.defaultEscrituraPrice}%`,
        this.defaultEscrituraPrice
      );
      this.contraentregageneral.options[2] = new Option(`${20}%`, 20);
      this.contraentregageneral.value = this.defaultEscrituraPrice;
    }
    if (lote.Almacen === "A-118") {
      //ferrara
      this.dropdownenganche.add(new Option(`10%`, 10));
      this.dropdownenganche.add(new Option(`15%`, 15));
      this.dropdownenganche.add(new Option(`20%`, 20));
      this.dropdownenganche.add(new Option(`30%`, 30));
      this.dropdownenganche.add(new Option(`40%`, 40));
      this.dropdownenganche.add(new Option(`50%`, 50));
      this.dropdownenganche.add(new Option(`60%`, 60));
      this.dropdownenganche.add(new Option(`70%`, 70));
      this.dropdownenganche.add(new Option(`80%`, 80));
      this.dropdownenganche.add(new Option(`1 Exhibición (contado)`, 100));
      this.enganche = 10;

      this.dropdownplazo.add(new Option(`3 meses`, 3));
      this.dropdownplazo.add(new Option(`6 meses`, 6));
      this.dropdownplazo.add(new Option(`12 meses`, 12));
      this.dropdownplazo.add(new Option(`18 meses`, 18));
      this.dropdownplazo.add(new Option(`24 meses`, 24));
      this.dropdownplazo.add(new Option(`30 meses`, 30));
      // mesesBase > 12
      //   ? this.dropdownplazo.add(new Option(`12 meses`, 12))
      //   : false;
      // mesesBase > 18
      //   ? this.dropdownplazo.add(new Option(`18 meses`, 18))
      //   : false;
      // this.dropdownplazo.add(
      //   new Option(`${mesesBase} meses`, mesesBase, false, true)
      // );
      this.plazos = 3;
      this.escritura = this.defaultEscrituraPrice;
      // this.percentcontraentrega.innerText = `${this.defaultEscrituraPrice} %`;
      this.escritura = this.defaultEscrituraPrice;
      this.contraentregageneral.options[1] = new Option(
        `${this.defaultEscrituraPrice}%`,
        this.defaultEscrituraPrice
      );
      this.contraentregageneral.options[2] = new Option(`${20}%`, 20);
      this.contraentregageneral.value = this.defaultEscrituraPrice;
    }
    if (lote.Almacen === "A-115AB") {
      //ferraralote.Almacen === "A-115AB"
      this.dropdownenganche.add(new Option(`10%`, 10));
      this.dropdownenganche.add(new Option(`15%`, 15));
      this.dropdownenganche.add(new Option(`20%`, 20));
      this.dropdownenganche.add(new Option(`30%`, 30));
      this.dropdownenganche.add(new Option(`40%`, 40));
      this.dropdownenganche.add(new Option(`50%`, 50));
      this.dropdownenganche.add(new Option(`60%`, 60));
      this.dropdownenganche.add(new Option(`70%`, 70));
      this.dropdownenganche.add(new Option(`80%`, 80));
      this.dropdownenganche.add(new Option(`1 Exhibición (contado)`, 100));
      this.enganche = 10;

      this.dropdownplazo.add(new Option(`3 meses`, 3));
      this.dropdownplazo.add(new Option(`6 meses`, 6));
      this.dropdownplazo.add(new Option(`12 meses`, 12));
      this.dropdownplazo.add(new Option(`18 meses`, 18));
      this.dropdownplazo.add(new Option(`24 meses`, 24));
      this.dropdownplazo.add(new Option(`30 meses`, 30));
      // mesesBase > 12
      //   ? this.dropdownplazo.add(new Option(`12 meses`, 12))
      //   : false;
      // mesesBase > 18
      //   ? this.dropdownplazo.add(new Option(`18 meses`, 18))
      //   : false;
      // this.dropdownplazo.add(
      //   new Option(`${mesesBase} meses`, mesesBase, false, true)
      // );
      this.plazos = 3;
      this.escritura = this.defaultEscrituraPrice;
      // this.percentcontraentrega.innerText = `${this.defaultEscrituraPrice} %`;
      this.escritura = this.defaultEscrituraPrice;
      this.contraentregageneral.options[1] = new Option(
        `${this.defaultEscrituraPrice}%`,
        this.defaultEscrituraPrice
      );
      this.contraentregageneral.options[2] = new Option(`${20}%`, 20);
      this.contraentregageneral.value = this.defaultEscrituraPrice;
    }
    if (lote.Almacen === "C4") {
      //ferraralote.Almacen === "A-115AB"
      // this.dropdownenganche.add(new Option(`10%`, 10));
      // this.dropdownenganche.add(new Option(`15%`, 15));
      this.dropdownenganche.add(new Option(`20%`, 20));
      this.dropdownenganche.add(new Option(`30%`, 30));
      this.dropdownenganche.add(new Option(`40%`, 40));
      this.dropdownenganche.add(new Option(`50%`, 50));
      this.dropdownenganche.add(new Option(`60%`, 60));
      this.dropdownenganche.add(new Option(`70%`, 70));
      this.dropdownenganche.add(new Option(`80%`, 80));
      this.dropdownenganche.add(new Option(`1 Exhibición (contado)`, 100));
      this.enganche = 20;

      this.dropdownplazo.add(new Option(`3 meses`, 3));
      this.dropdownplazo.add(new Option(`6 meses`, 6));
      this.dropdownplazo.add(new Option(`12 meses`, 12));
      this.dropdownplazo.add(new Option(`18 meses`, 18));
      this.dropdownplazo.add(new Option(`24 meses`, 24));
      this.dropdownplazo.add(new Option(`30 meses`, 30));
      // mesesBase > 12
      //   ? this.dropdownplazo.add(new Option(`12 meses`, 12))
      //   : false;
      // mesesBase > 18
      //   ? this.dropdownplazo.add(new Option(`18 meses`, 18))
      //   : false;
      // this.dropdownplazo.add(
      //   new Option(`${mesesBase} meses`, mesesBase, false, true)
      // );
      this.plazos = 3;
      this.escritura = 20;
      // this.percentcontraentrega.innerText = `${this.defaultEscrituraPrice} %`;
      this.escritura = 20;
      this.contraentregageneral.options[1] = new Option(`${20}%`, 20);
      this.contraentregageneral.value = 20;
    }
    if (lote.Almacen === "A-35" || lote.Almacen === "A-101D") {
      //TerraVerde
      this.dropdownenganche.add(new Option(`20%`, 20));
      this.dropdownenganche.add(new Option(`30%`, 30));
      this.dropdownenganche.add(new Option(`40%`, 40));
      this.dropdownenganche.add(new Option(`50%`, 50));
      this.dropdownenganche.add(new Option(`60%`, 60));
      this.dropdownenganche.add(new Option(`70%`, 70));
      this.dropdownenganche.add(new Option(`80%`, 80));
      this.dropdownenganche.add(new Option(`1 Exhibición (contado)`, 100));
      this.enganche = 20;

      this.dropdownplazo.add(new Option(`3 meses`, 3));
      this.dropdownplazo.add(new Option(`6 meses`, 6));
      this.dropdownplazo.add(new Option(`12 meses`, 12));
      this.plazos = 3;
      this.escritura = 20;
      this.escritura = 20;
      this.contraentregageneral.options[1] = new Option(`${20}%`, 20);
      this.contraentregageneral.value = 20;
    }
  }

  calcularVNA(tasa = 1.01156817456, flujos, F24) {
    // Inicializar el valor neto actual (VNA) en 0
    let vna = 0;
    // formula real de abajo ` let tasaAjustada = Math.pow(1 + tasa, 1 / 12) - 1;  `
    // pero da mejor precisionq ue xcel entonces se toma el valor que arroja scel y se harcodea aqui
    // let tasaAjustada = tasa - 1;
    let tasaAjustada = Math.pow(1 + tasa, 1 / 12) - 1;
    for (var i = 0; i < flujos.length; i++) {
      vna += flujos[i] / Math.pow(1 + tasaAjustada, i + 1);
    }
    return vna + F24;
  }
}
